<template>
	<div>
		<DetailDriver ref="modalDetailDriver"></DetailDriver>
		<ModalDriver ref="modalDriver" :propAdd='paramProp' :val = 'val' @action="save"></ModalDriver>
		<modalconfirm ref="modalconfirmDriver" @action="deleteData"/>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Data Driver</div>
		</div>
		<v-card class="mt-3 mb-3" outlined>
			<v-list color="deep-purple lighten-5" dark class="pa-3">
				<v-list-item dense class="px-1">
					<v-btn dark depressed class="primary lighten-1" @click.stop="tambahDriver">
						<v-icon>mdi-plus-circle</v-icon>
						<div class="pl-2 text-capitalize">Tambah Driver</div>
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn text depressed class="primary lighten-1 mr-2">
						<v-icon>mdi-export</v-icon>
						<div class="pl-2 text-capitalize">Export</div>
					</v-btn>
					<v-btn class="primary lighten-1" text dark @click="dropfilter = !dropfilter">
						<v-icon>mdi-filter</v-icon>
						<div class="pl-2 text-capitalize">Filter</div>
						<v-icon v-if="!dropfilter">mdi-menu-down</v-icon>
						<v-icon v-if="dropfilter">mdi-menu-up</v-icon>
					</v-btn>
				</v-list-item>
			</v-list>
		</v-card>

		<v-slide-y-transition>
			<v-card outlined class="pa-2 mb-2" v-if="dropfilter">
				<v-card
					outlined
					class="pa-2 mb-2"
				>
					<v-col cols="12" class="py-0">
						<v-row>
							<v-col cols="12" md="3" >
								<v-text-field outlined dense hide-details label="Username" v-model="username.value" color="primary lighten-1"></v-text-field>
							</v-col>
							<v-col cols="12" md="3" >
								<v-text-field outlined dense hide-details label="Nama Driver" v-model="name.value" color="primary lighten-1"></v-text-field>
							</v-col>
							<v-col cols="12" md="3" >
								<v-text-field outlined dense hide-details label="No. SIM" v-model="passport.value" color="primary lighten-1"></v-text-field>
							</v-col>
							<v-col cols="12" md="3" >
								<v-text-field outlined dense hide-details label="No. Handphone" v-model="phone.value" color="primary lighten-1"></v-text-field>
							</v-col>
							<!-- <v-col cols="12" md="3" >
								<v-text-field outlined dense hide-details label="Email" v-model="email.value" color="primary lighten-1"></v-text-field>
							</v-col> -->
						</v-row>
					</v-col>
				</v-card>

				<v-col cols="12" class="pa-0">
					<v-row>
						<v-col cols="12" md="12" class="my-auto text-right">
							<v-btn outlined color="grey darken-1" dark class="text-capitalize" @click="resetFilter()"><v-icon class="mr-1" dense>mdi-autorenew</v-icon>Reset</v-btn>
							<v-btn depressed color="primary lighten-1" dark class="ml-2 text-capitalize" @click="cari()"><v-icon class="mr-1" dense>mdi-magnify</v-icon>Cari</v-btn>
						</v-col>
					</v-row>
				</v-col>
			</v-card>
		</v-slide-y-transition>
		<v-card outlined>
			<v-data-table :headers="headers" :items="listDriver" :loading="loading" loading-text="Sedang memuat data..." :items-per-page="limit" hide-default-footer no-data-text="Tidak ada data tersedia">
				<template v-slot:item.driver_status="{ item }">
					<div>
						<template v-if="item.driver_status === 'stand_by'">
							<v-tooltip right color="green darken-1">
								<template v-slot:activator="{ on, attrs }">
									<v-icon color="green" medium v-bind="attrs" v-on="on">mdi-check-circle</v-icon>
								</template>
								<span>{{ item.driver_status | statusDriver }}</span>
							</v-tooltip>
						</template>

						<template v-else>
							<v-tooltip right>
								<template v-slot:activator="{ on, attrs }">
									<v-icon color="grey lighten-2" medium v-bind="attrs" v-on="on">mdi-checkbox-blank-circle</v-icon>
								</template>
								<span>{{ item.driver_status | statusDriver }}</span>
							</v-tooltip>
						</template>
					</div>
				</template>
				<template v-slot:item.driver_last_run_datetime="{ item }">
					{{ (item.driver_last_run_datetime) ? formatDateText(item.driver_last_run_datetime, 'DD-MM-YYYY hh:mm') : '-' }}
				</template>
				<template v-slot:item.driver_is_active="{ item }">
					<v-switch color="primary lighten-1" v-model="item.driver_is_active" @change="editStatus(item)"></v-switch>
				</template>
				<template v-slot:item.action="{ item }">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn class="mr-1" fab dark x-small depressed color="teal lighten-2" v-bind="attrs" v-on="on" @click.stop="getDetail(item.driver_id)">
								<v-icon dark>mdi-text-box-search</v-icon>
							</v-btn>
						</template>
						<span>Detail</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn class="mr-1" fab dark x-small depressed color="indigo" v-bind="attrs" v-on="on" @click.stop="editDriver(item)">
								<v-icon dark>mdi-pencil</v-icon>
							</v-btn>
						</template>
						<span>Edit</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn class="" fab dark x-small depressed color="pink" v-bind="attrs" v-on="on" @click.stop="showConfirmation(item.driver_id, item.driver_name)">
								<v-icon dark>mdi-delete</v-icon>
							</v-btn>
						</template>
						<span>Hapus</span>
					</v-tooltip>
				</template>
			</v-data-table>

		</v-card>
		<div class="pt-5">
			<v-row>
				<v-col cols="12" md="11" class="py-0 d-flex justify-start">
					<v-pagination v-model="page" :length="driverPagination.total_page" total-visible="5" circle class="d-flex justify-end no-button-focus" color="primary lighten-1" @input="changePage"></v-pagination>
				</v-col>
				<v-col cols="12" md="1" class="py-0 pl-0">
					<v-autocomplete :items="listLimit" v-model="limit" hide-details class="mt-0" label="Item" color="primary lighten-1" @input="changeLimit"></v-autocomplete>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import { mapActions,  mapState, mapMutations } from 'vuex'
import moment from 'moment';
import ModalDriver from './ModalDriver';
import DetailDriver from './DetailDriver';

export default {
	components: {
		ModalDriver, DetailDriver
	},
	data () {
		return {
			dropfilter: false,
			loading: false,
			page: 1,
			limit: 10,
			listLimit: [ '5', '10', '20', '50', '100' ],
			params:[],
			paramProp: '',
			propDelete: '',
			val: {},
			headers: [
			{ text: 'Status', align: 'center', sortable: false, value: 'driver_status' },
			{ text: 'No. SIM', sortable: false, value: 'driver_passport' },
			{ text: 'Username', align: 'start', sortable: false, value: 'driver_username' },
			{ text: 'Nama Driver', sortable: false, value: 'driver_name' },
			{ text: 'No. Handphone', sortable: false, value: 'driver_mobilephone' },
			{ text: 'Email', sortable: false, value: 'driver_email' },
			{ text: 'Ekspedisi', align: 'center', sortable: false, value: 'driver_run_count' },
			{ text: 'Ekspedisi Terakhir', align: 'center', sortable: false, value: 'driver_last_run_datetime' },
			{ text: 'Aktif', align: 'center', sortable: false, value: 'driver_is_active' },
			{ text: 'Aksi', align: 'end', sortable: false, value: 'action' },
			],
			username: {
				value:'',
				comparison:'like',
				type:'string',
				field:'driver_username'
			},
			passport: {
				value:'',
				comparison:'like',
				type:'string',
				field:'driver_passport'
			},
			name: {
				value:'',
				comparison:'like',
				type:'string',
				field:'driver_name'
			},
			phone: {
				value:'',
				comparison:'like',
				type:'string',
				field:'driver_mobilephone'
			},
			email: {
				value:'',
				comparison:'like',
				type:'string',
				field:'driver_email'
			},
			paramStatus : {
				id : '',
				status : ''
			}
		}
	},
	computed: {
		...mapState('driver', ['listDriver', 'driverPagination', 'responSukses']),
	},
	methods: {
		...mapActions('driver', ['getDriver', 'getDetailDriver', 'add', 'update', 'delete', 'status']),
		...mapMutations('driver', ['saveResponse']),

		getDetail(id) {
			this.getDetailDriver(id).then(()=> {
				this.$refs.modalDetailDriver.modalShow()
			})
		},
		tambahDriver() {
			this.paramProp = 'tambah'
			this.$refs.modalDriver.modalShow({
				username: '',
				password: '',
				passport : '',
				name : '',
				place_of_birth : '',
				date_of_birth: '',
				email: '',
				mobilephone: '',
				gender: '',
				address: ''
			})
		},
		save(data){
			if(this.paramProp == 'tambah') {
				this.add(data).then( () => {
					if(this.responSukses.code == 200) {
						this.getDriver(this.queryString({limit:this.limit, page: this.page, params:this.params}))
						this.$refs.modalDriver.modalHide()
						this.saveResponse({})
					}
				})
			} 
			else {
				this.update(data).then( () => {
					if(this.responSukses.code == 200) {
						this.getDriver(this.queryString({limit:this.limit, page: this.page, params:this.params}))
						this.$refs.modalDriver.modalHide()
						this.saveResponse({})
					}
				})
			}
		},
		editDriver(item) {
			this.val = item;
			this.paramProp = 'edit'
			this.$refs.modalDriver.modalShow()
		},
		showConfirmation(id, name){
			this.propDelete = id
			let msg = `Yakin ingin menghapus ${name}`
			this.$refs.modalconfirmDriver.setMessage(msg)
			this.$refs.modalconfirmDriver.showConfirm()
		},
		deleteData() {
			this.delete(this.propDelete).then( () => {
				this.getDriver(this.queryString({limit:this.limit, page: this.page, params:this.params}))
				this.$refs.modalconfirmDriver.hideConfirm()
			})
		},
		editStatus(stat){
			this.paramStatus.id = stat.driver_id
			if (stat.driver_is_active == false) {
				this.paramStatus.status = 'inactive'
			} else {
				this.paramStatus.status = 'active'
			}
			this.status(this.paramStatus).then(() => {
				this.getDriver(this.queryString({limit:this.limit, page: this.page, params:this.params}))
			})
		},
		cari() {
			this.params = []
			if(this.username.value)
				this.params.push(this.username)

			if(this.passport.value)
				this.params.push(this.name)

			if(this.name.value)
				this.params.push(this.name)

			if(this.email.value)
				this.params.push(this.email)

			if(this.phone.value)
				this.params.push(this.phone)

			this.getDriver(this.queryString({limit:this.limit, page: 1, params:this.params}))
		},
		resetFilter() {
			this.username.value = ''
			this.passport.value = ''
			this.email.value = ''
			this.phone.value = ''
			this.name.value = ''
			this.params = []
			this.limit = 10
			this.getDriver(this.queryString({limit:this.limit, page: 1, params:this.params}))
		},
		changePage(page) {
			this.page = page
			this.getDriver(this.queryString({limit:this.limit, page: this.page, params:this.params}))
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getDriver(this.queryString({limit:this.limit, page: this.page, params:this.params}))
		},
		formatDateText(params, format) {
			let dates = (params) ? new Date(params) : null
			return (dates) ? moment(dates).format(format) : null
		},
		async getListDriver() {
			this.loading = await true
			this.getDriver(this.queryString({limit:this.limit, page: this.page})).then(() => {
				setTimeout(() => {
					this.loading = false
				}, 1000)
			})
			.catch(() => {
				setTimeout(() => {
					this.loading = false
				}, 1000)
			})
		}
	},
	async mounted() {
		this.$store.dispatch('setPageTitle', `Data Driver`)
		this.getListDriver()
	}
};

</script>
